import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import TerritoryDefinition from "./pages/TerritoryDefinition/TerritoryDefinition";
import TerritoryAllocation from "./pages/TerritoryAllocation/TerritoryAllocation";
import ParentChildFacility from "./pages/ParentChildFacility/ParentChildFacility";
import ParentChildChange from "./pages/ParentChildChange/ParentChildChange";
import OrganizationCustomer from "./pages/OrganizationCustomer/OrganizationCustomer";
import PersonCustomer from "./pages/PersonCustomer/PersonCustomer";
import NewCustomerRequest from "./pages/NewCustomerRequest/NewCustomerRequest";
import CustomerRequestStatus from "./pages/CustomerRequestStatus/CustomerRequestStatus";
import OrganizationCustomerDetails from "./pages/CustomerRequestStatus/OrganizationCustomerDetails";
import PersonCustomerDetails from "./pages/CustomerRequestStatus/PersonCustomerDetails";
import AffiliationDetails from "./pages/CustomerRequestStatus/AffiliationDetails";
import OrganizationParent from './pages/OrganizationCustomer/OrganizationDetails/OrganizationParent';
import AffiliatedPersonnel from "./pages/OrganizationCustomer/OrganizationDetails/AffiliatedPersonnel";
import ChildFacilities from "./pages/OrganizationCustomer/OrganizationDetails/ChildFacilities";
import ParentFacilities from "./pages/OrganizationCustomer/OrganizationDetails/ParentFacilities";
import AllocatedEmployees from "./pages/OrganizationCustomer/OrganizationDetails/AllocatedEmployees";
import HospitalFunctions from "./pages/OrganizationCustomer/OrganizationDetails/HospitalFunctions";
import PrefectureFunctions from "./pages/OrganizationCustomer/OrganizationDetails/PrefectureFunctions";
import NursingInfo from "./pages/OrganizationCustomer/OrganizationDetails/NursingInfo";
import PersonInfo from "./pages/PersonCustomer/PersonDetails/PersonInfo";
import OrganizationAttributeChange from "./pages/OrganizationCustomer/OrganizationAttributeChange";
import OrganizationClosure from "./pages/OrganizationCustomer/OrganizationClosure";
import PersonAttributeChange from "./pages/PersonCustomer/PersonAttributeChange";
import AffiliationAttributeChange from "./pages/PersonCustomer/AffiliationAttributeChange";
import Dashboard from "./pages/Dashboard";
import DailySellout from './pages/SalesReports/DailySellout';
import DailySelloutCA from "./pages/SalesReports/DailySelloutCA";
import MonthlySellout from "./pages/SalesReports/MonthlySellout";
import MonthlySelloutCA from './pages/SalesReports/MonthlySelloutCA';
import SelloutRotationFacility from './pages/SalesReports/SelloutRotationFacility';
import SelloutRotationWholesaler from './pages/SalesReports/SelloutRotationWholesaler';
import SalesMaintenance from "./pages/SalesMaintenance";
import SearchMembers from './pages/SalesReports/SearchMembers';
import Downloads from "./pages/SalesReports/Downloads";
import DailyProgress from './pages/EmailSettings/DailyProgress';
import ReceptionSlip from './pages/SalesReports/ReceptionSlip';
import IdleTimer from "./pages/IdleTimerComponent";
import Demo from "./pages/PersonCustomer/Demo"

// Antd CSS
import "antd/dist/reset.css";
import { organizationClosure } from './pages/OrganizationCustomer/actions';


function App(props) {
  const [role, setRole] = useState("");

  useEffect(() => {
    const role = sessionStorage.getItem("User role")
    setRole(role);
  })
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path='/' element={<OrganizationCustomer />} />
        <Route exact path='/territoryDefinition' element={<TerritoryDefinition />} />
        <Route exact path='/territoryAllocation' element={<TerritoryAllocation />} />
        <Route exact path='/parentChildFacility' element={<ParentChildFacility />} />
        <Route exact path='/parentChildChange' element={<ParentChildChange />} />
        <Route exact path='/organizationCustomer' element={<OrganizationCustomer />} />
        <Route exact path='/personCustomer' element={<PersonCustomer />} />
        <Route exact path='/demo' element={<Demo />} />

        <Route exact path='/newCustomerRequest' element={<NewCustomerRequest />} />
        <Route exact path='/customerRequestStatus' element={<CustomerRequestStatus />} />
        <Route exact path='/organizationInfo' element={<OrganizationParent />} />
        <Route exact path='/affiliatedPersonnel' element={<AffiliatedPersonnel />} />
        <Route exact path='/childFacilities' element={<ChildFacilities />} />
        <Route exact path='/parentFacilities' element={<ParentFacilities />} />
        <Route exact path='/allocatedEmployees' element={<AllocatedEmployees />} />
        <Route exact path='/hospitalFunctions' element={<HospitalFunctions />} />
        <Route exact path='/prefectureFunctions' element={<PrefectureFunctions />} />
        <Route exact path='/nursingInfo' element={<NursingInfo />} />
        <Route exact path='/personInfo' element={<PersonInfo />} />
        <Route exact path='/organizationAttributeChange' element={<OrganizationAttributeChange />} />
        <Route exact path='/organizationRequestResubmit' element={<OrganizationAttributeChange />} />
        <Route exact path='/organizationRequestEdit' element={<OrganizationAttributeChange />} />
        <Route exact path='/personRequestResubmit' element={<PersonAttributeChange />} />
        <Route exact path='/personRequestEdit' element={<PersonAttributeChange />} />
        <Route exact path='/affiliationRequestResubmit' element={<AffiliationAttributeChange />} />
        <Route exact path='/affiliationRequestEdit' element={<AffiliationAttributeChange />} />
        <Route exact path='/organizationClosure' element={<OrganizationClosure />} />
        <Route exact path='/organizationClosureRequestResubmit' element={<OrganizationClosure />} />
        <Route exact path='/organizationClosureRequestEdit' element={<OrganizationClosure />} />
        <Route exact path='/personAttributeChange' element={<PersonAttributeChange />} />
        <Route exact path='/affiliationChange' element={<AffiliationAttributeChange />} />
        <Route exact path='/affiliationRetirement' element={<AffiliationAttributeChange />} />
        <Route exact path='/newAffiliationRequest' element={<AffiliationAttributeChange />} />
        <Route exact path='/organizationCustomerDetails' element={<OrganizationCustomerDetails />} />
        <Route exact path='/personCustomerDetails' element={<PersonCustomerDetails />} />
        <Route exact path='/affiliationDetails' element={<AffiliationDetails />} />
        <Route exact path='/dailySelloutReport' element={<DailySellout />} />
        <Route exact path='/dailySelloutReportCA' element={<DailySelloutCA />} />
        <Route exact path='/monthlySelloutReport' element={<MonthlySellout />} />
        <Route exact path='/monthlySelloutReportCA' element={<MonthlySelloutCA />} />
        <Route exact path='/selloutRotationReportFacility' element={<SelloutRotationFacility />} />
        <Route exact path='/selloutRotationReportWholeSaler' element={<SelloutRotationWholesaler />} />
        <Route exact path='/searchMembers' element={<SearchMembers />} />
        <Route exact path='/downloads' element={<Downloads />} />
        <Route exact path='/dailyProgress' element={<DailyProgress />} />
        <Route exact path='/maintenance' element={<SalesMaintenance />} />
        <Route exact path='/reception' element={<ReceptionSlip />} />
        <Route exact path='/parent' element={<OrganizationParent />} />
        <Route path='*' element={<Navigate to="/" replace />} />


      </Routes>
    </BrowserRouter>
  );
}

export default App;
